import { Component, inject } from '@angular/core';

import {
  AgGridFooterComponent,
  CamGridDataService,
  FieldsSelectionDisplayerComponent,
  ViewSelectionDisplayerComponent,
  ViewsSelectionComponent,
} from '@camelot/core';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        AgGridFooterComponent,
        FieldsSelectionDisplayerComponent,
        TestIdDirective,
        ViewSelectionDisplayerComponent,
        ViewsSelectionComponent,
    ],
    template: `
    <cam-views-selection camTestId="cam-views-selection" [gridId]="this.gridId" />
    <cam-views-selection-displayer camTestId="cam-views-selection-displayer" [gridId]="this.gridId" />
    <cam-fields-selection-displayer camTestId="cam-fields-selection-displayer" [gridId]="this.gridId" />
    <cam-ag-grid-footer camTestId="cam-ag-grid-footer" [gridId]="this.gridId" [services]="null" />
  `
})
export class CoreGridAdvancedCase {
  public gridId = 'e2e-grid-advanced';

  private readonly _dataService = inject(CamGridDataService);

  ngOnInit(): void {
    this._dataService.get(this.gridId, true).switchView('grid');
  }
}
